"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RegistryNotificationsGraphQLService = void 0;
const BaseGraphQLService_1 = __importDefault(require("../BaseGraphQLService"));
const queries_1 = require("./queries");
const mutations_1 = require("./mutations");
class RegistryNotificationsGraphQLService extends BaseGraphQLService_1.default {
  constructor() {
    super(...arguments);
    this.getAvailableUsersForNotifications = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(queries_1.massHoaNotificationUsersList, variables, options, requestOptions);
      return response.data.registry.massHoaNotification.usersList;
    });
    this.getSelectedUsersForNotifications = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(queries_1.massHoaNotificationSelectedUsers, variables, options, requestOptions);
      return response.data.registry.massHoaNotification.selectedUsers;
    });
    this.getNotificationFilters = (options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(queries_1.massHoaNotificationFilters, {}, options, requestOptions);
      return response.data.registry.massHoaNotification.filters;
    });
    this.getNotificationShortStatistics = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(queries_1.massHoaNotificationShortStatistics, variables, options, requestOptions);
      return response.data.registry.massHoaNotification.statistic;
    });
    this.getNotificationFullStatistics = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(queries_1.massHoaNotificationFullStatistics, variables, options, requestOptions);
      return response.data.registry.massHoaNotification.statistic;
    });
    this.sendMassNotify = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.mutate(mutations_1.sendMassNotify, variables, options, requestOptions);
      return response.data.registry.sendMassNotify;
    });
    this.getAvailableUsersForInvite = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(queries_1.inviteToHoaNotificationUsersList, variables, options, requestOptions);
      return response.data.registry.inviteToHoaNotification.usersList;
    });
    this.getSelectedUsersForInvite = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(queries_1.inviteToHoaNotificationSelectedUsers, variables, options, requestOptions);
      return response.data.registry.inviteToHoaNotification.selectedUsers;
    });
    this.getInviteFilters = (options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(queries_1.inviteToHoaNotificationFilters, {}, options, requestOptions);
      return response.data.registry.inviteToHoaNotification.filters;
    });
    this.getInviteShortStatistics = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(queries_1.inviteToHoaNotificationShortStatistics, variables, options, requestOptions);
      return response.data.registry.inviteToHoaNotification.statistic;
    });
    this.getInviteFullStatistics = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(queries_1.inviteToHoaNotificationFullStatistics, variables, options, requestOptions);
      return response.data.registry.inviteToHoaNotification.statistic;
    });
    this.personalInvite = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.mutate(mutations_1.personalInvite, variables, options, requestOptions);
      return response.data.registry.personalInvite;
    });
    this.sendInviteToHOA = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.mutate(mutations_1.sendInviteToHoa, variables, options, requestOptions);
      return response.data.registry.sentInviteToHoa;
    });
    this.getTgBotInviteStatistics = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(queries_1.registryTgBotInviteStatistics, variables, options, requestOptions);
      return response.data.registry.massTgBotInvite.statistic;
    });
    this.sendInviteToTgBot = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.mutate(mutations_1.sendTgBotMassInvite, variables, options, requestOptions);
      return response.data.registry.sendTgBotMassInvite;
    });
    this.getOwnerTgBotInviteNotificationUsersList = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(queries_1.ownerTgBotInviteNotificationUsersList, variables, options, requestOptions);
      return response.data.registry.massTgBotInvite.usersList;
    });
    this.getOwnerTgBotInviteNotificationSelectedUsers = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(queries_1.ownerTgBotInviteNotificationSelectedUsers, variables, options, requestOptions);
      return response.data.registry.massTgBotInvite.selectedUsers;
    });
    this.getOwnerTgBotInviteNotificationFilters = (options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(queries_1.ownerTgBotInviteNotificationFilters, {}, options, requestOptions);
      return response.data.registry.massTgBotInvite.filters;
    });
    this.getOwnerTgBotInviteNotificationShortStatistics = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(queries_1.ownerTgBotInviteNotificationShortStatistics, variables, options, requestOptions);
      return response.data.registry.massTgBotInvite.statistic;
    });
    this.getOwnerTgBotInviteNotificationFullStatistics = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(queries_1.ownerTgBotInviteNotificationFullStatistics, variables, options, requestOptions);
      return response.data.registry.massTgBotInvite.statistic;
    });
  }
}
exports.RegistryNotificationsGraphQLService = RegistryNotificationsGraphQLService;
const registryNotificationsGraphQLService = new RegistryNotificationsGraphQLService();
exports.default = registryNotificationsGraphQLService;